<template>
    <div>
        <SkeletonBase
            has-title
            has-divided
        />
        <SkeletonBase
            v-for="n in 3"
            :key="n"
            class="hidden md:block"
            has-title
            :content-cols="6"
            :content="2"
            has-button
            has-divided
        />
        <SkeletonBase
            v-for="n in 3"
            :key="n"
            class="md:hidden"
            has-title
            :content-cols="2"
            :content="2"
            has-button
            has-divided
        />
    </div>
</template>

<script>
import SkeletonBase from '@/components/skeletons/SkeletonBase.vue';

export default {
    components: {
        SkeletonBase
    },
};
</script>
